import React, {Fragment, useContext} from "react";
import {View, Text} from '@react-pdf/renderer';
import PropTypes from "prop-types";

import {DISCOUNT_MAIN_TYPES, DISCOUNT_TYPES} from "../../priceWorksheet/discounstInterface";
import {getPriceWithCurrency, toFixedPrice} from "../../../misc/helpers";
import {getCustomDepositAmount, getSubTotalPrice} from "../../priceWorksheet/discountFunctions";
import PrintDocumentDiscountFinance from "./printDocumentDiscountFinance";
import {PrintDocumentContext} from "./printDocumentContext";

const PrintDocumentDiscount = (props) => {
  const {styles, discount, priceWorksheetState, discountSection, fabricatorSettings, grandTotal} = props;
  const {discountSections, customAddedDiscounts} = priceWorksheetState;

  const printContext = useContext(PrintDocumentContext);

  const getDiscountPercentageAmount = () => {
    const grandTotal = getSubTotalPrice(discountSections, discountSection, discount, true, customAddedDiscounts);
    const priceTaken = grandTotal * discount.amount / 100 // for ex. 25% from 2700 = 625
    return toFixedPrice(Math.trunc(priceTaken * 100) / 100);
  };

  if (discount.discountType === DISCOUNT_MAIN_TYPES.deposit) {
    return (
      <View style={[styles.cartItemInfo, styles.discountDeposit]} wrap={false}>
        <Text style={styles.cartItemName}>{discount.name}</Text>
        <Text style={styles.cartItemPrice}>
          {getPriceWithCurrency(fabricatorSettings, getCustomDepositAmount(discountSections, grandTotal))}
        </Text>
      </View>
    )
  }

  if (discount.discountType === DISCOUNT_MAIN_TYPES.finance) {
    return <PrintDocumentDiscountFinance {...props}/>
  }

  const discountAmount = discount.type === DISCOUNT_TYPES.price
    ? `-${getPriceWithCurrency(fabricatorSettings, toFixedPrice(discount.amount))}`
    : `(${discount.amount}%) \xa0\xa0\xa0\xa0 -${getPriceWithCurrency(fabricatorSettings, getDiscountPercentageAmount())}`;

  const approveOptions = discount.approveOptions ? JSON.parse(discount.approveOptions) : null;

  return (
    <View style={styles.cartItem} wrap={false}>
      <View style={styles.cartItemInfo}>
        <View style={[styles.flex, styles.flexRow, styles.flexCenter]}>
          <Text style={styles.cartItemName}>{discount.name}</Text>
          {approveOptions && approveOptions.selectedOption ? (
            <Fragment>
              <Text style={[styles.marginL20, styles.cartItemSimilarItemExample]}>{printContext.messages["receipt.discount.approvedBy"]}: </Text>
              <Text style={styles.cartItemName}>{approveOptions.selectedOption}</Text>
            </Fragment>
          ) : null}
        </View>
        <Text style={styles.cartItemPrice}>{discountAmount}</Text>
      </View>
    </View>
  )
};

PrintDocumentDiscount.propTypes = {
  discount: PropTypes.object.isRequired,
  priceWorksheetState: PropTypes.object.isRequired,
  discountSection: PropTypes.object.isRequired,
  fabricatorSettings: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
  grandTotal: PropTypes.number,
};

export default PrintDocumentDiscount
